// src/components/UserProfile.js
import React, { useContext, useState, useEffect } from "react";
import {
  Button,
  Card,
  CardHeader,
  CardBody,
  CardFooter,
  FormGroup,
  Form,
  Input,
  Row,
  Col,
} from "reactstrap";
import { DataContext } from "../context/DataContext";
import { API_BASE } from "../config/api";
// fallback avatar
// import fallbackAvatar from "assets/img/faces/placeholder.jpg"; // Assuming not used here anymore

import {
  SystemAlertsSettings,
  BudgetTargetsSettings,
  BannerSettings,
  DistributionSettings,
  BrandSettings,
  ProductTypeSettings,
  RegionSettings,
  UnitsOfMeasureSettings,
  BulkImportSettings,
  DownloadDataSettings,
  StoreTypeSettings // Import the new StoreTypeSettings component
} from './SettingsComponents'; // Import the new components

function Settings() {
  const { data, setData } = useContext(DataContext);
  const profile = data.userProfile || {};
  console.log("Settings:", data); // local form state for User Profile section
  const [form, setForm] = useState({
    name: "",
    title: "",
    city: "",
    country: "",
    about: "",
  });
  const [saving, setSaving] = useState(false);
  const [error, setError] = useState("");

  // sync when profile changes (e.g. initially loaded or after save)
  useEffect(() => {
    setForm({
      name: profile.name || "",
      title: profile.title || "",
      city: profile.city || "",
      country: profile.country || "",
      about: profile.about || "",
    });
  }, [profile]);

  function handleChange(e) {
    const { name, value } = e.target;
    setForm((f) => ({ ...f, [name]: value }));
  }

async function handleSaveUserProfile() { // Renamed to be specific
  setSaving(true);
  setError("");
  try {
    const res = await fetch(
      `${API_BASE}/users/${profile.id}`,
      {
        method: "PUT",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ ...profile, ...form }), // Merge with existing profile data
      }
    );
    if (!res.ok) throw new Error(`Save failed (${res.status})`);
    const updatedProfile = await res.json();
    setData((d) => ({ ...d, userProfile: updatedProfile }));
    alert("User profile updated successfully!");
  } catch (err) {
    console.error(err);
    setError(err.message || "Save failed");
  } finally {
    setSaving(false);
  }
}


  return (
    <div className="content">
 

      {/* System Settings Sections */}
      <Row className="mt-4">
        <Col md="12">
          <SystemAlertsSettings />
        </Col>
      </Row>
      <Row className="mt-4">
        <Col md="12">
          <BudgetTargetsSettings />
        </Col>
      </Row>

      <Row className="mt-4">
        <Col md="6">
          <ProductTypeSettings />
        </Col>
          <Col md="6">
          <StoreTypeSettings /> 
        </Col>

      </Row>
      <Row className="mt-4">
           <Col md="6">
          <RegionSettings />
        </Col>

        <Col md="6">
          <UnitsOfMeasureSettings />
          
        </Col>


      </Row>
            <Row className="mt-4">
        <Col md="6">
          <BannerSettings />
        </Col>
               <Col md="6">
          <BrandSettings />
        </Col>


      </Row>
      <Row className="mt-4">

        <Col md="12">
          <DistributionSettings />
        </Col>
      </Row>
      {/* <Row className="mt-4">
        <Col md="12">
          <BulkImportSettings />
        </Col>
      </Row> */}
      <Row className="mt-4">
        <Col md="12">
          <DownloadDataSettings />
        </Col>
      </Row>

    </div>
  );
}

export default Settings;
